import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import CreateLobbyForm from './components/CreateLobbyForm';
import PlayerJoin from './components/PlayerJoin';
import MatchmakingPage from './components/MatchmakingModal';
import AuthPage from './components/AuthPage';
import Dashboard from './components/Dashboard';
import LobbiesPage from './components/LobbiesPage';
import Navbar from './components/Navbar';
import { supabase } from './lib/supabase';
import './App.css';

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await supabase.auth.getUser();
        if (!mounted) return;
        setUser(res?.data?.user ?? null);
      } catch (err) {
        console.error('Auth check failed', err);
        if (!mounted) return;
        setUser(null);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    const { data: listener } = supabase.auth.onAuthStateChange((_event: any, session: any) => {
      if (session?.user) setUser(session.user);
      else setUser(null);
    });

    return () => {
      mounted = false;
      if (listener && typeof listener.subscription?.unsubscribe === 'function') {
        // @ts-ignore
        listener.subscription.unsubscribe();
      }
    };
  }, []);

  if (loading) return <div />;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};

const ProtectedLayout: React.FC = () => {
  return (
    <ProtectedRoute>
      <div>
        <Navbar />
        <main className="px-4">
          <Outlet />
        </main>
      </div>
    </ProtectedRoute>
  );
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100 pt-0 pb-8">
        <Routes>
          <Route path="/auth" element={<AuthPage />} />

          <Route path="/" element={<ProtectedLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="create" element={<CreateLobbyForm />} />
            <Route path="my-lobbies" element={<LobbiesPage />} />
            <Route path="lobby/:lobbyId/matchmaker" element={<MatchmakingPage />} />
          </Route>

          <Route path="/join/:lobbyId" element={<PlayerJoin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
